export default "__VITE_ASSET__D32VvLG8__"